export const FORM_IDENTIFIER = 'app/DonationCreditRulesFormPage';

export const INIT = 'app/DonationCreditRulesFormPage/INIT';
export const INIT_SUCCESS = 'app/DonationCreditRulesFormPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/DonationCreditRulesFormPage/INIT_FAILED';

export const SAVE = 'app/DonationCreditRulesFormPage/SAVE';
export const SAVE_SUCCESS = 'app/DonationCreditRulesFormPage/SAVE_SUCCESS';
export const SAVE_FAILED = 'app/DonationCreditRulesFormPage/SAVE_FAILED';

export const REMOVE = 'app/DonationCreditRulesFormPage/REMOVE';
export const REMOVE_SUCCESS = 'app/DonationCreditRulesFormPage/REMOVE_SUCCESS';
export const REMOVE_FAILED = 'app/DonationCreditRulesFormPage/REMOVE_FAILED';
